import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { DisclaimerFields, useDisclaimer } from "@/components/Disclaimer";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export const DisclaimerGate = ({ children }) => {
  const { user, setUser, logout } = useAuth();
  const disclaimer = useDisclaimer(["property_manager", "realtor"].includes(user?.role) ? "pm" : user?.role === "surety_agent" ? "surety" : "mlo");
  const [agree, setAgree] = useState(false);
  const [name, setName] = useState("");
  const [sigImage, setSigImage] = useState("");
  const [busy, setBusy] = useState(false);
  if (!user || user.role === "admin") return children;
  if (!disclaimer) return <div className="flex min-h-screen items-center justify-center" data-testid="disclaimer-loading"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  if (user.disclaimer?.version === disclaimer.version) return children;
  const sign = async () => {
    setBusy(true);
    try { const { data } = await api.post("/auth/disclaimer", { agree_disclaimer: agree, signature_name: name, signature_image: sigImage }); setUser(data); toast.success("Disclaimer signed"); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#37494d] p-4" data-testid="disclaimer-gate">
      <div className="w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl">
        <h1 className="font-display text-2xl font-extrabold text-slate-900">{disclaimer.kind === "pm" ? "Please sign the real estate associate disclaimer" : disclaimer.kind === "surety" ? "Please sign the surety agent disclaimer" : "Please sign the MLO disclaimer"}</h1>
        <p className="mb-4 mt-1 text-sm text-slate-500">You need to accept this before you continue using Elite Leads.</p>
        <DisclaimerFields disclaimer={disclaimer} agree={agree} setAgree={setAgree} name={name} setName={setName} setSigImage={setSigImage} />
        <div className="mt-4 flex justify-between gap-2">
          <Button variant="ghost" onClick={logout} data-testid="disclaimer-logout">Sign out</Button>
          <Button onClick={sign} disabled={busy || !agree || name.trim().length < 3 || !sigImage} className="gold-cta border-0 font-bold" data-testid="disclaimer-sign-btn">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign & continue"}
          </Button>
        </div>
      </div>
    </div>
  );
};
